module.exports = __webpack_public_path__ + "static/img/icon-safe3.2e5f563.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-safe3.png
// module id = qi0O
// module chunks = 21